'use strict'

function _typeof(obj) {
  '@babel/helpers - typeof'
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }
  return _typeof(obj)
}

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.SignatureField =
  exports.PrintedSignatureField =
  exports.PrintedRadioField =
  exports.PrintedCheckboxField =
  exports.OptionsField =
    void 0

var _react = _interopRequireWildcard(require('react'))

var _styledComponents = _interopRequireWildcard(require('styled-components'))

var _index = require('../../atoms/Label/index.js')

var _index2 = require('../../atoms/Typography/index.js')

var _index3 = require('../Flex/index.js')

var _index4 = require('../TextField/index.js')

var _excluded = [
    'id',
    'type',
    'label',
    'value',
    'onSave',
    'error',
    'options',
    'checked',
    'required',
    'disabled',
    'maxLength',
    'direction',
    'inputClassName',
  ],
  _excluded2 = [
    'id',
    'type',
    'label',
    'checked',
    'onSave',
    'error',
    'options',
    'required',
    'disabled',
  ]

var _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null
  var cacheBabelInterop = new WeakMap()
  var cacheNodeInterop = new WeakMap()
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop
  })(nodeInterop)
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj }
  }
  var cache = _getRequireWildcardCache(nodeInterop)
  if (cache && cache.has(obj)) {
    return cache.get(obj)
  }
  var newObj = {}
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc)
      } else {
        newObj[key] = obj[key]
      }
    }
  }
  newObj['default'] = obj
  if (cache) {
    cache.set(obj, newObj)
  }
  return newObj
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key]
          }
        }
      }
      return target
    }
  return _extends.apply(this, arguments)
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg)
    var value = info.value
  } catch (error) {
    reject(error)
    return
  }
  if (info.done) {
    resolve(value)
  } else {
    Promise.resolve(value).then(_next, _throw)
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args)
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value)
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err)
      }
      _next(undefined)
    })
  }
}

function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  )
}

function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  )
}

function _iterableToArray(iter) {
  if (
    (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) ||
    iter['@@iterator'] != null
  )
    return Array.from(iter)
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr)
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  )
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  )
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen)
  var n = Object.prototype.toString.call(o).slice(8, -1)
  if (n === 'Object' && o.constructor) n = o.constructor.name
  if (n === 'Map' || n === 'Set') return Array.from(o)
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen)
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i]
  }
  return arr2
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) || arr['@@iterator']
  if (_i == null) return
  var _arr = []
  var _n = true
  var _d = false
  var _s, _e
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value)
      if (i && _arr.length === i) break
    }
  } catch (err) {
    _d = true
    _e = err
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']()
    } finally {
      if (_d) throw _e
    }
  }
  return _arr
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {}
  var target = _objectWithoutPropertiesLoose(source, excluded)
  var key, i
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source)
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i]
      if (excluded.indexOf(key) >= 0) continue
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue
      target[key] = source[key]
    }
  }
  return target
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {}
  var target = {}
  var sourceKeys = Object.keys(source)
  var key, i
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i]
    if (excluded.indexOf(key) >= 0) continue
    target[key] = source[key]
  }
  return target
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

var OptionInput = _styledComponents['default'].input(
  _templateObject || (_templateObject = _taggedTemplateLiteral(['\n  opacity: 0;\n']))
)

var OptionLabel = _styledComponents['default'].label(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteral([
      '\n  display: flex;\n  align-items: center;\n  position: relative;\n  left: -13px;\n',
    ]))
)

var OptionLabelText = _styledComponents['default'].span(
  _templateObject3 || (_templateObject3 = _taggedTemplateLiteral(['\n  ', '\n'])),
  function (props) {
    return (
      props.required &&
      "\n    &::before {\n      content: '* ';\n      color: ".concat(
        props.theme.colors.error,
        ';\n    }\n  '
      )
    )
  }
)

var Option = _styledComponents['default'].div(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteral([
      '\n  padding-right: ',
      ';\n  padding-bottom: ',
      ';\n  opacity: ',
      ';\n  display: flex;\n',
    ])),
  function (props) {
    return props.theme.spacing(3)
  },
  function (props) {
    return props.theme.spacing(1.5)
  },
  function (props) {
    return props.disabled ? 0.6 : 1
  }
)

var OptionsField = function OptionsField(_ref) {
  var id = _ref.id,
    type = _ref.type,
    label = _ref.label,
    value = _ref.value,
    onSave = _ref.onSave,
    error = _ref.error,
    options = _ref.options,
    checked = _ref.checked,
    required = _ref.required,
    disabled = _ref.disabled,
    maxLength = _ref.maxLength,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'column' : _ref$direction,
    inputClassName = _ref.inputClassName,
    props = _objectWithoutProperties(_ref, _excluded)

  var _useState = (0, _react.useState)(value || []),
    _useState2 = _slicedToArray(_useState, 2),
    localState = _useState2[0],
    setLocalState = _useState2[1]

  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    saving = _useState4[0],
    setSaving = _useState4[1] // lastSelected keeps track of the most recently selected option
  // so when we display the saving state, we know which option changed

  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    lastSelected = _useState6[0],
    setLastSelected = _useState6[1]

  var onCheckboxChange = function onCheckboxChange(value) {
    var newState = _toConsumableArray(localState) // check new box

    if (!localState.includes(value)) {
      if (localState.length === maxLength) {
        newState.pop()
      }

      newState.push(value)
      setLocalState(newState) //uncheck box
    } else {
      newState = localState.filter(function (val) {
        return val !== value
      })
      setLocalState(newState)
    }

    return newState
  }

  var saveData = /*#__PURE__*/ (function () {
    var _ref2 = _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee(e) {
        var value
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch ((_context.prev = _context.next)) {
              case 0:
                value = type === 'Checkboxes' ? onCheckboxChange(e.target.value) : e.target.value
                setLastSelected(e.target.value)
                setSaving(true)
                _context.t0 = onSave

                if (!_context.t0) {
                  _context.next = 7
                  break
                }

                _context.next = 7
                return onSave(value)

              case 7:
                setSaving(false)

              case 8:
              case 'end':
                return _context.stop()
            }
          }
        }, _callee)
      })
    )

    return function saveData(_x) {
      return _ref2.apply(this, arguments)
    }
  })()

  return /*#__PURE__*/ _react['default'].createElement(
    'div',
    {
      key: id,
    },
    /*#__PURE__*/ _react['default'].createElement(
      _index.Label,
      {
        className: 'fs-unmask',
        required: required,
        error: !!error,
        disabled: disabled || saving,
      },
      label
    ),
    /*#__PURE__*/ _react['default'].createElement(
      _index3.Flex,
      {
        flexDirection: direction,
        alignItems: 'flex-start',
        className: inputClassName,
      },
      options.map(function (opt) {
        return /*#__PURE__*/ _react['default'].createElement(
          Option,
          {
            key: ''.concat(opt, '-').concat(id),
            disabled: disabled || saving,
          },
          /*#__PURE__*/ _react['default'].createElement(
            OptionInput,
            _extends(
              {
                id: 'option-'.concat(opt, '-').concat(id),
                type: type === 'Checkboxes' ? 'checkbox' : 'radio',
                name: type === 'Checkboxes' ? opt : ''.concat(id),
                disabled: disabled || saving,
                checked: Array.isArray(value) ? value.includes(opt) : value === opt,
                value: opt,
                onChange: saveData,
              },
              props
            )
          ),
          /*#__PURE__*/ _react['default'].createElement(
            OptionLabel,
            {
              htmlFor: 'option-'.concat(opt, '-').concat(id),
            },
            /*#__PURE__*/ _react['default'].createElement(OptionBox, {
              type: type === 'Checkboxes' ? 'checkbox' : 'radio',
              saving: saving && lastSelected === opt, // for checkboxes, we only want to indicate the changed value
              checked: Array.isArray(value) ? value.includes(opt) : value === opt,
            }),
            opt
          )
        )
      })
    ),
    error &&
      /*#__PURE__*/ _react['default'].createElement(
        _index3.Flex,
        {
          justifyContent: 'flex-end',
        },
        /*#__PURE__*/ _react['default'].createElement(
          _index2.Typography,
          {
            as: 'label',
            color: 'error',
            padding: '0 2 0 0',
            style: {
              opacity: error ? 1 : 0,
            },
          },
          error
        )
      )
  )
}

exports.OptionsField = OptionsField

var SignatureField = function SignatureField(_ref3) {
  var id = _ref3.id,
    type = _ref3.type,
    label = _ref3.label,
    checked = _ref3.checked,
    onSave = _ref3.onSave,
    error = _ref3.error,
    options = _ref3.options,
    required = _ref3.required,
    disabled = _ref3.disabled,
    props = _objectWithoutProperties(_ref3, _excluded2)

  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    saving = _useState8[0],
    setSaving = _useState8[1]

  var saveData = /*#__PURE__*/ (function () {
    var _ref4 = _asyncToGenerator(
      /*#__PURE__*/ regeneratorRuntime.mark(function _callee2(e) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch ((_context2.prev = _context2.next)) {
              case 0:
                setSaving(true)
                _context2.t0 = onSave

                if (!_context2.t0) {
                  _context2.next = 5
                  break
                }

                _context2.next = 5
                return onSave(!checked)

              case 5:
                setSaving(false)

              case 6:
              case 'end':
                return _context2.stop()
            }
          }
        }, _callee2)
      })
    )

    return function saveData(_x2) {
      return _ref4.apply(this, arguments)
    }
  })()

  return /*#__PURE__*/ _react['default'].createElement(
    'div',
    {
      key: id,
    },
    /*#__PURE__*/ _react['default'].createElement(
      _index3.Flex,
      {
        flex: '1',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
      },
      /*#__PURE__*/ _react['default'].createElement(
        Option,
        {
          disabled: disabled || saving,
        },
        /*#__PURE__*/ _react['default'].createElement(
          OptionInput,
          _extends(
            {
              id: 'checkbox-'.concat(id),
              type: 'checkbox',
              name: 'checkbox-'.concat(id),
              disabled: disabled || saving,
              checked: checked,
              onChange: saveData,
            },
            props
          )
        ),
        /*#__PURE__*/ _react['default'].createElement(
          OptionLabel,
          {
            htmlFor: 'checkbox-'.concat(id),
          },
          /*#__PURE__*/ _react['default'].createElement(OptionBox, {
            type: 'checkbox',
            saving: saving,
            checked: checked,
          }),
          /*#__PURE__*/ _react['default'].createElement(
            OptionLabelText,
            {
              required: required,
            },
            label
          )
        )
      )
    ),
    error &&
      /*#__PURE__*/ _react['default'].createElement(
        _index3.Flex,
        {
          justifyContent: 'flex-end',
        },
        /*#__PURE__*/ _react['default'].createElement(
          _index2.Typography,
          {
            as: 'label',
            color: 'error',
            padding: '0 2 0 0',
            style: {
              opacity: error ? 1 : 0,
            },
          },
          error
        )
      )
  )
}

exports.SignatureField = SignatureField
var rotate = (0, _styledComponents.keyframes)(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteral([
      '\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n',
    ]))
)

var OptionBox = _styledComponents['default'].div(
  _templateObject6 ||
    (_templateObject6 = _taggedTemplateLiteral([
      '\n  min-width: 20px;\n  min-height: 20px;\n  max-width: 20px;\n  background-color: #dedede;\n  border-radius: ',
      ';\n  margin-right: ',
      ';\n  transition: background-color 0.2s, border-radius 0.2s;\n  ',
      ':focus & {\n    border: 2px solid ',
      ';\n  }\n  ',
      '\n  ',
      '\n',
    ])),
  function (props) {
    return props.type === 'radio' ? '20px' : '5px'
  },
  function (props) {
    return props.theme.spacing(1)
  },
  OptionInput,
  function (props) {
    return props.theme.colors.primary
  },
  function (props) {
    return props.checked ? OptionBoxChecked : ''
  },
  function (props) {
    return props.saving ? OptionBoxSaving : ''
  }
)

var OptionBoxSaving = (0, _styledComponents.css)(
  _templateObject7 ||
    (_templateObject7 = _taggedTemplateLiteral([
      '\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  background: transparent;\n  margin-right: ',
      ';\n  border: 2px solid ',
      ';\n  border-bottom-color: transparent;\n  animation: ',
      ' 1s linear infinite;\n',
    ])),
  function (props) {
    return props.theme.spacing(1)
  },
  function (props) {
    return props.theme.colors.success
  },
  rotate
)
var OptionBoxChecked = (0, _styledComponents.css)(
  _templateObject8 ||
    (_templateObject8 = _taggedTemplateLiteral([
      '\n  background-color: ',
      ';\n  left: 3px;\n  top: 3px;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #dedede;\n',
    ])),
  function (props) {
    return props.theme.colors.success
  }
)
/****************** PRINTABLE COMPONENTS BELOW ********************/

var PrintedCheckboxField = function PrintedCheckboxField(_ref5) {
  var label = _ref5.label,
    options = _ref5.options,
    value = _ref5.value
  return /*#__PURE__*/ _react['default'].createElement(
    _react['default'].Fragment,
    null,
    /*#__PURE__*/ _react['default'].createElement(StyledLabel, null, label, ':'),
    /*#__PURE__*/ _react['default'].createElement(
      Grid, // flex="1"
      // alignItems="center"
      // margin="0 8px 0 8px"
      // justifyContent="space-between"
      // flexWrap="wrap"
      null,
      options.map(function (option, index) {
        return /*#__PURE__*/ _react['default'].createElement(
          _index3.Flex,
          {
            key: option + index,
            margin: '0 16px 0 0',
            alignItems: 'flex-end',
          },
          /*#__PURE__*/ _react['default'].createElement(
            _index4.StyledValue,
            {
              style: {
                width: '10mm',
              },
            },
            value.includes(option) ? 'X' : '  '
          ),
          /*#__PURE__*/ _react['default'].createElement(StyledOptionLabel, null, option)
        )
      })
    )
  )
}

exports.PrintedCheckboxField = PrintedCheckboxField

var PrintedRadioField = function PrintedRadioField(_ref6) {
  var label = _ref6.label,
    options = _ref6.options,
    value = _ref6.value
  return /*#__PURE__*/ _react['default'].createElement(
    _react['default'].Fragment,
    null,
    /*#__PURE__*/ _react['default'].createElement(StyledLabel, null, label, ':'),
    /*#__PURE__*/ _react['default'].createElement(
      Grid, // flex="1"
      // alignItems="center"
      // margin="0 8px 0 8px"
      // justifyContent="space-between"
      // flexWrap="wrap"
      null,
      options.map(function (option, index) {
        return /*#__PURE__*/ _react['default'].createElement(
          _index3.Flex,
          {
            key: option + index,
            margin: '0 16px 0 0',
            alignItems: 'flex-end',
          },
          /*#__PURE__*/ _react['default'].createElement(
            _index4.StyledValue,
            {
              style: {
                width: '10mm',
              },
            },
            value === option ? 'X' : '  '
          ),
          /*#__PURE__*/ _react['default'].createElement(StyledOptionLabel, null, option)
        )
      })
    )
  )
}

exports.PrintedRadioField = PrintedRadioField

var PrintedSignatureField = function PrintedSignatureField(_ref7) {
  var label = _ref7.label,
    signature = _ref7.signature,
    dateSigned = _ref7.dateSigned
  return /*#__PURE__*/ _react['default'].createElement(
    _react['default'].Fragment,
    null,
    /*#__PURE__*/ _react['default'].createElement(
      _index3.Flex,
      {
        flex: '1',
        flexDirection: 'column',
      },
      /*#__PURE__*/ _react['default'].createElement(
        _index3.Flex,
        {
          flexDirection: 'column',
        },
        /*#__PURE__*/ _react['default'].createElement(
          _index3.Flex,
          {
            margin: '0 0 10px 0',
          },
          /*#__PURE__*/ _react['default'].createElement(StyledOptionLabel, null, label)
        ),
        /*#__PURE__*/ _react['default'].createElement(_index4.StyledValue, null, signature)
      ),
      /*#__PURE__*/ _react['default'].createElement(
        _index3.Flex,
        {
          margin: '5px 0 0 0',
          justifyContent: 'space-between',
        },
        /*#__PURE__*/ _react['default'].createElement(
          _index2.Typography,
          {
            as: 'p',
            padding: '0 0 0 4px',
          },
          'Signed: '.concat(dateSigned ? dateSigned : '')
        )
      )
    )
  )
} // const StyledSignature = styled(StyledValue)`
//   &&& {
//     font-family: Brush Script MT, Brush Script Std, cursive;
//     font-size: 38px;
//     font-weight: 300;
//     padding-bottom: 4px;
//     width: 100%;
//   }
// `

exports.PrintedSignatureField = PrintedSignatureField

var Grid = _styledComponents['default'].div(
  _templateObject9 ||
    (_templateObject9 = _taggedTemplateLiteral([
      '\n  flex: 1;\n  min-width: 100%;\n  display: grid;\n  grid-template-columns: 33% 33% 33%;\n',
    ]))
)

var StyledLabel = _styledComponents['default'].p(
  _templateObject10 ||
    (_templateObject10 = _taggedTemplateLiteral([
      '\n  width: 100%;\n  margin-top: 12px;\n  margin-bottom: 0;\n',
    ]))
)

var StyledOptionLabel = _styledComponents['default'].span(
  _templateObject11 ||
    (_templateObject11 = _taggedTemplateLiteral([
      '\n  font-size: 14px;\n  padding-left: 4px;\n  margin-bottom: -3px;\n',
    ]))
)
